import * as Sentry from '@sentry/vue'

function getKioskId(): string | null {
    const fromStorage = localStorage.getItem('kiosk_id');
    if (fromStorage) return fromStorage;

    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('kiosk_id');
    if (fromQuery) return fromQuery;

    const fromWindow = window.kiosk_id;
    if (fromWindow) return fromWindow;

    return null;
}

export { getKioskId };

export function getTerminalTags(): Record<string, string> {
    const tags: Record<string, string> = {};

    const storageKeys = ['terminal_id', 'cafe_slug', 'shop_id', 'terminal_type'];
    for (const key of storageKeys) {
        const value = localStorage.getItem(key);
        if (value) {
            tags[key] = value;
        }
    }

    const kioskId = getKioskId();
    if (kioskId) {
        tags.kiosk_id = kioskId;
    }

    return tags;
}

export function captureException(error: unknown, options: Sentry.CaptureContext = {}): string {
    const terminalTags = getTerminalTags();
    return Sentry.captureException(error, {
        ...options,
        tags: {
            ...(options as { tags?: Record<string, string | number | boolean> }).tags,
            ...terminalTags,
        },
    });
}

export function captureMessage(message: string, options: Sentry.CaptureContext = {}): string {
    const terminalTags = getTerminalTags();
    return Sentry.captureMessage(message, {
        ...options,
        tags: {
            ...(options as { tags?: Record<string, string | number | boolean> }).tags,
            ...terminalTags,
        },
    });
}